import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag_horizontal",
  "use": "drag_horizontal-usage",
  "viewBox": "0 0 14.75 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.75 4\" id=\"drag_horizontal\"><defs></defs><g class=\"cls-1\"><path d=\"M14.75 2.67V4h-1.33V2.67zm0-2.67v1.33h-1.33V0zm-2.67 0v1.33h-1.33V0zm0 2.67V4h-1.33V2.67zM9.45 0v1.33H8.12V0zm0 2.67V4H8.12V2.67zM6.67 2.67V4H5.33V2.67zm0-2.67v1.33H5.33V0zM4 2.67V4H2.67V2.67zM4 0v1.33H2.67V0zM1.33 0v1.33H0V0zm0 2.67V4H0V2.67z\" class=\"cls-2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol